/**
 * ARIA Collapsible Dropdown Listbox Example
 * @function onload
 * @desc Initialize the listbox once the page has loaded
 */

import { aria } from './listbox.js';
// isotope
import * as iso from './isotope-jobs.js';

window.addEventListener('load', function () {
  var buttonPlace = document.getElementById('listbox_button_place');  
  var listboxPlace = new aria.Listbox(document.getElementById('listbox_list_place'));
  var listboxButtonPlace = new aria.ListboxButton(buttonPlace, listboxPlace);
  
  //var buttonDate = document.getElementById('listbox_button_date');
  //var listboxDate = new aria.Listbox(document.getElementById('listbox_list_date'));
  //var listboxButtonDate = new aria.ListboxButton(buttonDate, listboxDate);
  
  var buttonFunction = document.getElementById('listbox_button_function');
  var listboxFunction = new aria.Listbox(document.getElementById('listbox_list_function'));
  var listboxButtonFunction = new aria.ListboxButton(buttonFunction, listboxFunction);
  
  var buttonType = document.getElementById('listbox_button_type');
  var listboxType = new aria.Listbox(document.getElementById('listbox_list_type'));
  var listboxButtonType = new aria.ListboxButton(buttonType, listboxType);
  
  var isoHashFilter = iso.getHashFilter();
  
  if (isoHashFilter) {
    if (iso.hasFilterData.func !== '') {
      console.log(iso.hasFilterData.func);
      var $functionItemToFocus = document.getElementById(iso.hasFilterData.func);
      if ($functionItemToFocus) {
        listboxFunction.focusItem($functionItemToFocus)
      }      
    }
    
    if (iso.hasFilterData.place !== '') {
      console.log(iso.hasFilterData.place);
      var $placeItemToFocus = document.getElementById(iso.hasFilterData.place);
      if ($placeItemToFocus) {
        listboxPlace.focusItem($placeItemToFocus)
      }      
    }
    
    /*if (iso.hasFilterData.date !== '') {
      console.log(iso.hasFilterData.date);
      var $dateItemToFocus = document.getElementById(iso.hasFilterData.date);
      if ($dateItemToFocus) {
        listboxDate.focusItem($dateItemToFocus)
      }      
    }*/
    
    if (iso.hasFilterData.type !== '') {
      console.log(iso.hasFilterData.type);
      var $typeItemToFocus = document.getElementById(iso.hasFilterData.type);
      if ($typeItemToFocus) {
        listboxType.focusItem($typeItemToFocus)
      }      
    }
  }
  //console.log(listboxPlace.focusItem($itemToFocus));
});

//var aria = aria || {};

aria.ListboxButton = function (button, listbox) {
  this.button = button;
  this.listbox = listbox;
  this.registerEvents();
};

aria.ListboxButton.prototype.registerEvents = function () {
  this.button.addEventListener('click', this.showListbox.bind(this));
  this.button.addEventListener('keyup', this.checkShow.bind(this));
  this.listbox.listboxNode.addEventListener('blur', this.hideListbox.bind(this));
  this.listbox.listboxNode.addEventListener('keydown', this.checkHide.bind(this));
  this.listbox.setHandleFocusChange(this.onFocusChange.bind(this));
};

aria.ListboxButton.prototype.checkShow = function (evt) {
  var key = evt.which || evt.keyCode;

  switch (key) {
    case aria.KeyCode.UP:
    case aria.KeyCode.DOWN:
      evt.preventDefault();
      this.showListbox();
      this.listbox.checkKeyPress(evt);
      break;
  }
};

aria.ListboxButton.prototype.checkHide = function (evt) {
  var key = evt.which || evt.keyCode;

  switch (key) {
    case aria.KeyCode.RETURN:
    case aria.KeyCode.ESC:
      evt.preventDefault();
      this.hideListbox();
      this.button.focus();
      break;
  }
};

aria.ListboxButton.prototype.showListbox = function () {
  aria.Utils.removeClass(this.listbox.listboxNode, 'u-hidden');
  this.button.setAttribute('aria-expanded', 'true');
  this.listbox.listboxNode.focus();
};

aria.ListboxButton.prototype.hideListbox = function () {
  aria.Utils.addClass(this.listbox.listboxNode, 'u-hidden');
  this.button.removeAttribute('aria-expanded');
};

aria.ListboxButton.prototype.onFocusChange = function (focusedItem) {
  this.button.innerText = focusedItem.innerText;
};
